import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as BaseShield } from 'assets/images/autos/icon-shield.svg';

export const Container: any = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;
  box-shadow: 0 2px 16px 0 rgb(0 0 0 / 10%);
  border-radius: 8px;
  background-color: ${ColorPalette.HEX.White};
  margin: 24px 0;
`;

Container.Icon = styled.div`
  margin: 0 16px;
  width: 24px;
  height: 24px;
`;

Container.Content = styled.div`
  p {
    color: ${ColorPalette.HEX.OuterSpace};
    font-size: 14px;
    margin-right: 16px;
    strong {
      font-weight: 600;
    }
  }
`;

export const IconShield = styled(BaseShield)`
  color: ${({ theme }) => theme.primaryBackgroundColor};
  width: 24px;
  height: 24px;
`;
